var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-text-field',_vm._b({attrs:{"outlined":"","value":_vm.modelValue,"prefix":"₹"},on:{"keypress":_vm.keyPress,"input":(newValue) => (_vm.modelValue = newValue)}},'v-text-field',_vm.$props,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }